import { createSlice } from '@reduxjs/toolkit';

import setExpandedWidthReducer from './reducer/setExpandedWidthReducer';
import setLivePreviewScenesReducer from './reducer/setLivePreviewScenesReducer';
import setSelectedSceneReducer from './reducer/setSelectedSceneReducer';
import setSizeReducer from './reducer/setSizeReducer';
import { LivePreviewState } from './types';

export const livePreviewInitialState: LivePreviewState = {
  areaTokens: [],
  scenes: [],
  size: 'small',
};

export const slice = createSlice({
  name: 'livePreview',
  initialState: livePreviewInitialState,
  reducers: {
    setLivePreviewScenesAction: setLivePreviewScenesReducer,
    setSelectedSceneAction: setSelectedSceneReducer,
    setSizeAction: setSizeReducer,
    setExpandedWidthAction: setExpandedWidthReducer,
  },
});

export const { setLivePreviewScenesAction, setSelectedSceneAction, setSizeAction, setExpandedWidthAction } =
  slice.actions;

const livePreviewReducer = slice.reducer;

export default livePreviewReducer;
